import React, { Fragment } from 'react';
import '../../style.css';
import { withTranslation } from 'react-i18next';
import moment from 'moment';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';
import { Typography } from '../../../../components/Wrappers';

class CustomContentTemplate extends React.PureComponent {
  // handleConfirm() {
  //     console.log('Customer confirmation!');
  //     Alert.close(this.props.id);
  // }

  getAlert = (value) => {
    const { t } = this.props;
    let result = `${t('unknown')}`;
    switch (value) {
      case 1:
        result = `${t('lying')}`;
        break;
      case 2:
        result = `${t('sitting')}`;
        break;
      case 3:
        result = `${t('standing')}`;
        break;
      case 4:
        result = `${t('walking')}`;
        break;
      case 5:
        result = `${t('Running')}`;
        break;
      case 6:
        result = `${t('Jumping')}`;
        break;
      case 7:
        result = `${t('lying_on_back')}`;
        break;
      case 8:
        result = `${t('lying_on_stomach')}`;
        break;
      case 9:
        result = `${t('lying_on_left_side')}`;
        break;
      case 10:
        result = `${t('lying_on_right_side')}`;
        break;
      case 501:
        result = `${t('get_up')}`;
        break;
      case 502:
        result = `${t('movement')}`;
        break;
      case 503:
        result = `${t('low_battery')}`;
        break;
      case 504:
        result = `${t('alert_last_seen')}`;
        break;
      case 505:
        result = `${t('alert_router_no_signal')}`;
        break;
      case 506:
        result = `${t('alert_not_turn')}`;
        break;
      case 507:
        result = `${t('alert_no_movement')}`;
        break;
      case 508:
        result = `${t('alert_fall')}`;
        break;
      case 509:
        result = `${t('alert_exit')}`;
        break;
      case 510:
        result = `${t('alert_near')}`;
        break;
      case 511:
        result = `${t('alert_walking')}`;
        break;
      case 512:
        result = `${t('alert_deactivate_recharge')}`;
        break;
      case 513:
        result = `${t('alert_bad_signal')}`;
        break;
      case 514:
        result = `${t('alert_emergency_alarm')}`;
        break;
      default:
        break;
    }
    return result;
  };

  getFullname = (patient) => {
    let fullname = '';

    if (localStorage.getItem('i18nextLng') === 'th-TH') {
      fullname = `${patient.firstname ?? ''} ${patient.lastname ?? ''}`;
    }
    if (localStorage.getItem('i18nextLng') === 'en-EN') {
      let firstname = patient.firstnameEn ? patient.firstnameEn : patient.firstname;
      let lastname = patient.lastnameEn ? patient.lastnameEn : patient.lastname;
      fullname = `${firstname ?? ''} ${lastname ?? ''}`;
    }
    return fullname;
  };

  getContent(style) {
    const { t } = this.props;
    let result = '';
    const color = '#009D9A';

    let alertPlace = '';
    const alertTypes = [];
    (this.props.customFields.notification || []).forEach((notif) => {
      if (notif.alerts && notif.alerts.length > 0) {
        notif.alerts = notif.alerts.filter((a) => a.alertType !== 513);
        notif.alerts.forEach((a) => {
          alertPlace = a.alertFixedEmergencyPlace;
          alertTypes.push(this.getAlert(a.alertType));
        });
      }
    });

    let alertText = '';
    (alertTypes || []).forEach((element) => {
      alertText = alertText.length > 0 ? `${alertText}, ${element}` : element;
    });

    if (this.props.customFields.dbStatus) {
      if (this.props.customFields.userName) {
        result = (
          <div className={this.props.classNames} id={this.props.id} style={style}>
            <div style={{ position: 'relative' }}>
              <IconButton
                edge='start'
                color='inherit'
                aria-label='close'
                onClick={this.props.handleClose}
                style={{ color: color, position: 'absolute', width: 4, height: 4, right: '-15px', top: '-15px' }}
              >
                <CloseIcon />
              </IconButton>
            </div>
            <Typography size='sm' color='textSecondary'>
              {moment(this.props.customFields.notification.alertTime).format('HH:mm')}
            </Typography>
            {/* <h4 style={{ color: color, marginTop: "0.5em" }}>
                {moment(this.props.customFields.notification.alertTime).format(
                  "HH:mm"
                )}
            </h4> */}
            <h4 style={{ color: color, marginTop: '0.5em' }}>
              <b>
                {this.props.customFields.patient
                  ? this.getFullname(this.props.customFields.patient)
                  : `@ ${alertPlace}`}{' '}
                {`[${alertText}]`}
              </b>
            </h4>
            {/* <h4 style={{ color: color, marginTop: "0.5em" }}>
              <b>{t("happened")}: </b>{" "}
              {this.props.customFields.patient
                ? this.getFullname(this.props.customFields.patient)
                : alertPlace}
            </h4> */}
            <h4 style={{ marginTop: '0.2em', color: '#4A4A4A' }}>
              <b>
                {t('by')} {this.props.customFields.userName}
              </b>
            </h4>
            {/* <span
              className="s-alert-close"
              style={{color: color}}
              onClick={this.props.handleClose}
            ></span> */}
          </div>
        );
      } else {
        result = (
          <div className={this.props.classNames} id={this.props.id} style={this.props.styles}>
            <div className='s-alert-box-inner' style={{ fontWeight: 'bold', textAlign: 'center' }}>
              {t('cannot_connect_router')} : {this.props.customFields.router}
            </div>
          </div>
        );
      }
    } else if (!this.props.customFields.dbStatus && this.props.customFields.alertType === 514) {
      result = (
        <div className={this.props.classNames} id={this.props.id} style={style}>
          <h4 style={{ color: color, marginTop: '0.5em' }}>
            {moment(this.props.customFields.alertTime).format('h:mm A')}
          </h4>
          <h4 style={{ color: color, marginTop: '0.5em' }}>
            {t('alert_type')} : {t('alert_emergency_alarm')}
          </h4>
          <h4 style={{ color: color, marginTop: '0.5em' }}>
            {t('device_place')} : {this.props.customFields.alertFixedEmergencyPlace}
          </h4>
          <span className='s-alert-close' onClick={this.props.customFields.handleCloseSound}></span>
        </div>
      );
    } else {
      result = (
        <div className={this.props.classNames} id={this.props.id} style={this.props.styles}>
          <div className='s-alert-box-inner' style={{ fontWeight: 'bold', textAlign: 'center' }}>
            {t('cannot_connect_database')}
          </div>
        </div>
      );
    }
    return result;
  }

  render() {
    let style = this.props.styles;
    style['marginTop'] = '24px';
    style['zIndex'] = '9999';
    style['background'] = 'white';
    style['boxShadow'] = '0 2px 4px 1px rgba(0, 0, 0, 0.06)';
    // style["background"] =
    //   this.props.customFields.type === "critical" && "rgb(176, 0, 32)";
    return <Fragment>{this.getContent(style)}</Fragment>;
  }
}

// export default CustomContentTemplate;
// export const translation = withTranslation()(CustomContentTemplate);
export default withTranslation()(CustomContentTemplate);
